export function WebAnimationsApiAccordion(): void {
  const details: NodeListOf<HTMLDetailsElement> = document.querySelectorAll(".js-accordion-details");
  const RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

  const animTiming: KeyframeAnimationOptions = {
    duration: 300,
    easing: "ease-out"
  };

  const closingAnimKeyframes = (content: HTMLElement): Keyframe[] => [
    {
      height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
      opacity: 1,
    },
    {
      height: '0',
      opacity: 0,
    }
  ];

  const openingAnimKeyframes = (content: HTMLElement): Keyframe[] => [
    {
      height: '0',
      opacity: 0,
    },
    {
      height: content.offsetHeight + 'px',
      opacity: 1,
    }
  ];

  details.forEach((element) => {
    const summary = element.querySelector<HTMLElement>(".js-accordion-summary");
    const content = element.querySelector<HTMLElement>(".js-accordion-content");

    if (summary && content) {
      summary.addEventListener("click", (event: MouseEvent) => {
        // デフォルトの挙動を無効化
        event.preventDefault();

        // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
        if (element.dataset.animStatus === RUNNING_VALUE) {
          return;
        }

        // detailsのopen属性を判定
        if (element.open) {
          // アコーディオンを閉じるときの処理
          // アイコン操作用クラスを切り替える(クラスを取り除く)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を付与
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーションの完了後に
          closingAnim.onfinish = () => {
            // open属性を取り除く
            element.removeAttribute("open");
            // アニメーション実行中用の値を取り除く
            element.dataset.animStatus = "";
          };
        } else {
          // アコーディオンを開くときの処理
          // open属性を付与
          element.setAttribute("open", "");

          // アイコン操作用クラスを切り替える(クラスを付与)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を入れる
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーション完了後にアニメーション実行中用の値を取り除く
          openingAnim.onfinish = () => {
            element.dataset.animStatus = "";
          };
        }
      });
    }
  });

  // アコーディオン外をクリックしたら全て閉じる
  document.addEventListener("click", (event: MouseEvent) => {
    details.forEach((element) => {
      // data 属性が付いていない場合は対象外
      const closeOutside = element.dataset.closeOutside === "true";
      if (!closeOutside) return;

      const summary = element.querySelector<HTMLElement>(".js-accordion-summary");
      const content = element.querySelector<HTMLElement>(".js-accordion-content");

      if (!summary || !content) return;

      // クリックされた要素がこの details の中なら何もしない
      if (element.contains(event.target as Node)) {
        return;
      }

      // すでに閉じている or アニメーション中なら何もしない
      if (!element.open || element.dataset.animStatus === RUNNING_VALUE) {
        return;
      }

      // 閉じるアニメーション
      element.classList.remove(IS_OPENED_CLASS);
      const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
      element.dataset.animStatus = RUNNING_VALUE;

      closingAnim.onfinish = () => {
        element.removeAttribute("open");
        element.dataset.animStatus = "";
      };
    });
  });
}
